import { render, staticRenderFns } from "./TabEndereco.vue?vue&type=template&id=43e87b5d&"
import script from "./TabEndereco.vue?vue&type=script&lang=js&"
export * from "./TabEndereco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports